import React, { Component } from 'react';
import Header from '../../header/header';
import TestForm from '../../TestForm';
import Aside from '../../aside';

class PageEditTest extends Component {
  state = {
    edit: true,
    url: ''
  };

  componentDidMount() {
    const params = this.props.match.params;
    this.setState({
      url: params.name
    });
  }

  render() {
    return (
      <React.Fragment>
        <Header />
        <div className="admin-container">
          <TestForm
            updateForm={this.updateForm}
            status={this.state.edit}
            testType={this.props.match.params.type || 1}
            url={this.state.url}
          />
          <Aside />
        </div>
      </React.Fragment>
    );
  }
}

export default PageEditTest;
